import { render, staticRenderFns } from "./JobMatching.vue?vue&type=template&id=3a68760b&scoped=true&"
import script from "./JobMatching.vue?vue&type=script&lang=js&"
export * from "./JobMatching.vue?vue&type=script&lang=js&"
import style0 from "./JobMatching.vue?vue&type=style&index=0&id=3a68760b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a68760b",
  null
  
)

export default component.exports